import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ScannedBarcodeData, Toast } from '../types/models.ts';
import { QuarantineStatusEnum, QuarantineStatusAction } from '../enums.ts';

export const QUARANTINE_QUERY_KEY = 'QUARANTINE_QUERY_KEY';

const useCreateOneQuarantine = (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    ScannedBarcodeData & {
      customerLocationId: number | string;
      note: string;
    }
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [endpoints.quarantine.create.one.quarantine()],
    mutationFn: api.quarantine.create.one.quarantine,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUARANTINE_QUERY_KEY],
      });
    },
    ...options,
  });
};

const useCreateOneStatus = (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    {
      status: QuarantineStatusEnum;
      action: QuarantineStatusAction;
      note: string;
      quarantineId: number;
      force?: boolean;
    }
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [endpoints.quarantine.create.one.status()],
    mutationFn: api.quarantine.create.one.status,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUARANTINE_QUERY_KEY],
      });
    },
    ...options,
  });
};

interface ReceiveManyByIdParams {
  meds: {
    quarantineId: string | number;
    epcisSgtinId: string | number;
  }[];
}

const useUpdateReceiveManyById = (
  options?: UseMutationOptions<Toast | null, unknown, ReceiveManyByIdParams>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [endpoints.quarantine.update.many.by.id()],
    mutationFn: api.quarantine.update.many.by.id,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUARANTINE_QUERY_KEY],
      });
    },
    ...options,
  });
};

const quarantineMutationHooks = {
  useCreateOneQuarantine,
  useCreateOneStatus,
  useUpdateReceiveManyById,
};

export default quarantineMutationHooks;
